module.exports = __webpack_public_path__ + "static/media/redux.c8f44df3.webp";